import styled from "styled-components";
import { CARD_BACKGROUND, COLORS, TableCell } from "../../../constants/Styles";

export const ParentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
`;

export const UploadContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
`;

export const ToolContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 24rem;
  ${CARD_BACKGROUND};
  padding: 2rem;
  border-radius: 1rem;
`;

export const WideToolContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 50rem;
  ${CARD_BACKGROUND};
  padding: 2rem;
  border-radius: 1rem;
`;

export const ToolContainerRow = styled.div`
  display: flex;
  gap: 2rem;
`;

export const ContainerCard = styled.div`
  padding: 1rem;
  margin: 1rem;
  background-color: ${COLORS.badgeGray};
  border-radius: 3px;
`;

export const FeederBaseDetails = styled.div`
  display: flex;
  gap: 3rem;
  align-items: flex-start;
`;

export const FeederTableCell = styled(TableCell)<{ backgroundColor?: string }>`
  ${({ backgroundColor }) => `background-color: ${backgroundColor};`}
  font-variant-numeric: tabular-nums;
`;

export const ScoreColumnHeader = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: flex-start;
`;

export const WarningsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  align-items: flex-start;
`;

export const WidthMismatchWarning = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const FeederBaseContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;
